import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OpenGateMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type OpenGateMutation = { __typename?: 'mutation_root', open_gate_site: Array<{ __typename?: 'gate_open', id: string }> };


export const OpenGateDocument = gql`
    mutation OpenGate($id: String!) {
  open_gate_site(args: {gate: $id}) {
    id
  }
}
    `;
export type OpenGateMutationFn = Apollo.MutationFunction<OpenGateMutation, OpenGateMutationVariables>;

/**
 * __useOpenGateMutation__
 *
 * To run a mutation, you first call `useOpenGateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenGateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openGateMutation, { data, loading, error }] = useOpenGateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOpenGateMutation(baseOptions?: Apollo.MutationHookOptions<OpenGateMutation, OpenGateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OpenGateMutation, OpenGateMutationVariables>(OpenGateDocument, options);
      }
export type OpenGateMutationHookResult = ReturnType<typeof useOpenGateMutation>;
export type OpenGateMutationResult = Apollo.MutationResult<OpenGateMutation>;
export type OpenGateMutationOptions = Apollo.BaseMutationOptions<OpenGateMutation, OpenGateMutationVariables>;